export default __webpack_public_path__ + "static/1_18-dded9cb0fe1bc7ec6af4252cc6ea4115.png";